module.exports = __webpack_public_path__ + "static/img/sorry.f97510f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sorry.png
// module id = xt23
// module chunks = 2